/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Radio, Row, Spin } from "antd";
import { useForm } from "react-hook-form";
import { InputField, InputPhone } from "../../../../../atoms/FormFields";
import { useEffect, useState } from "react";
import {
  createClientContact,
  updateClientContactById,
} from "../../../ducks/services";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch } from "../../../../../config/hooks";
import { getClientContacts } from "../../../ducks/actions";

const antIcon = <Loading3QuartersOutlined spin />;

interface FormValues {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  title: string;
  preferred_method_of_contact: string;
}

interface PropsType {
  onClose: () => void;
  companyId: string;
  clientId: string | null;
  setContacts: any;
  contactIndex: null | number;
  setContactIndex: any;
  contacts: any;
  editData: any;
}

export default function AddContactPopUp(props: PropsType) {
  const { onClose, companyId, clientId, editData } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [methodContact, setMethodContact] = useState("any");
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm<FormValues>();

  console.log("editData", editData);

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    const payload = {
      client_id: clientId as string,
      company_id: companyId,
      phone: val?.phone ? val?.phone : undefined,
      first_name: val?.first_name,
      last_name: val?.last_name,
      title: val?.title ? val?.title : undefined,
      email: val?.email ? val?.email : undefined,
      preferred_method_of_contact: methodContact,
      is_starred: false,
      is_signing: false,
      is_billing: false,
      is_contractor: false,
    };

    if (editData?.id) {
      updateClientContactById(editData?.id, payload)
        .then(() => {
          setLoading(false);
          SuccessMessage("contact updated");
          dispatch(getClientContacts(clientId as string));
          onClose();
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    } else {
      createClientContact(payload)
        .then(() => {
          setLoading(false);
          SuccessMessage("New contact added");
          dispatch(getClientContacts(clientId as string));
          onClose();
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    }
  };

  useEffect(() => {
    if (editData?.id) {
      setValue("first_name", editData?.first_name);
      setValue("last_name", editData?.last_name);
      setValue("phone", editData?.phone);
      setValue("email", editData?.email);
      setValue("title", editData?.title);
      setValue(
        "preferred_method_of_contact",
        editData?.preferred_method_of_contact
      );
      setMethodContact(editData?.preferred_method_of_contact || "any");
    } else {
      setValue("first_name", "");
      setValue("last_name", "");
      setValue("phone", "");
      setValue("email", "");
      setValue("title", "");
      setValue("preferred_method_of_contact", "any");
      setMethodContact("any");
    }
  }, [editData, setValue]);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        autoComplete="off"
        name="dependencies"
      >
        <div className="modalWrapper addContactModal">
          <div className="modal_header">
            <div className="title">
              <h3>{editData?.id ? "Edit contact" : "Add new contact"}</h3>
            </div>
          </div>

          <div className="modal_content">
            <Row gutter={16}>
              <Col span={12}>
                <InputField
                  fieldName="first_name"
                  label="First name"
                  control={control}
                  iProps={{
                    placeholder: "Enter first name",
                  }}
                  isRequired
                  rules={{
                    required: "First name is required.",
                  }}
                  validate={errors.first_name && "error"}
                  validMessage={errors.first_name && errors.first_name.message}
                />
              </Col>

              <Col span={12}>
                <InputField
                  fieldName="last_name"
                  label="Last name"
                  control={control}
                  iProps={{
                    placeholder: "Enter last name",
                  }}
                  isRequired
                  rules={{
                    required: "Last name is required.",
                  }}
                  validate={errors.last_name && "error"}
                  validMessage={errors.last_name && errors.last_name.message}
                />
              </Col>
              <Col span={24}>
                <InputField
                  fieldName="title"
                  label="Title"
                  control={control}
                  iProps={{
                    placeholder: "Enter title",
                  }}
                  // isRequired
                  // rules={{
                  //   required: "Title name is required.",
                  // }}
                  // validate={errors.title && "error"}
                  // validMessage={errors.title && errors.title.message}
                />
              </Col>
              <Col span={12}>
                <InputPhone fieldName="phone" label="Phone" control={control} />
              </Col>
              <Col span={12}>
                <InputField
                  fieldName="email"
                  label="Email"
                  control={control}
                  iProps={{
                    placeholder: "Enter email",
                  }}
                  rules={{
                    validate: (val: string) => {
                      if (!val) return true;
                      const value = val.trim();
                      const regex =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                      return (
                        regex.test(value) ||
                        "Please enter a valid email address."
                      );
                    },
                  }}
                  validate={errors.email && "error"}
                  validMessage={errors.email && errors.email.message}
                />
              </Col>
              <Col span={24} style={{ display: "flex" }}>
                <div style={{ fontWeight: "500" }}>
                  Preferred method of contact:
                </div>

                <div
                  className="preferredMethodRadio"
                  style={{ paddingLeft: "16px" }}
                >
                  <Radio.Group
                    onChange={(e) => setMethodContact(e.target.value)}
                    value={methodContact}
                  >
                    <Radio value="any">Any</Radio>
                    <Radio value="phone">Phone</Radio>
                    <Radio value="email">Email</Radio>
                  </Radio.Group>
                </div>
              </Col>
            </Row>
          </div>

          <div className="modal_footer" style={{ justifyContent: "flex-end" }}>
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="mint-btn"
              // disabled={!isDirty || !isValid}
            >
              Save contact
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
}
